"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_select_1 = __importDefault(require("react-select"));
const prop_types_1 = __importDefault(require("prop-types"));
const EMPTY_OBJ = {};
const CHEVRON_WIDTH = 33;
const SelectWithDynamicWidth = ({ styles, maxWidth, minWidth, ...otherProps }) => {
    const selectRef = (0, react_1.useRef)();
    const [menuIsOpen, setMenuIsOpen] = (0, react_1.useState)(false);
    const [menuWidth, setMenuWidth] = (0, react_1.useState)(null);
    const [isCalculatingWidth, setIsCalculatingWidth] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (!menuWidth && !isCalculatingWidth) {
            setTimeout(() => {
                setIsCalculatingWidth(true);
                // setIsOpen doesn't trigger onOpenMenu, so calling internal method
                (selectRef.current?.select).openMenu();
                setMenuIsOpen(true);
            }, 1);
        }
    }, [menuWidth, isCalculatingWidth]);
    const onMenuOpen = (0, react_1.useCallback)(() => {
        if (!menuWidth && isCalculatingWidth) {
            setTimeout(() => {
                const { width } = selectRef?.current?.select?.menuListRef?.getBoundingClientRect() || { width: undefined };
                setMenuWidth(width);
                setIsCalculatingWidth(false);
                // setting isMenuOpen to undefined and closing menu
                selectRef.current.select.onMenuClose();
                setMenuIsOpen(undefined);
            }, 1);
        }
    }, [isCalculatingWidth, menuWidth]);
    const dynamicStyles = (0, react_1.useMemo)(() => ({
        ...styles,
        menu: (css) => ({
            ...css,
            width: 'max-content',
            maxWidth,
            minWidth,
            ...(isCalculatingWidth && { height: 0, visibility: 'hidden' }),
        }),
        control: (css) => ({ ...css, display: 'inline-flex ' }),
        valueContainer: (css) => ({
            minWidth: minWidth - CHEVRON_WIDTH,
            ...css,
            ...(menuWidth && { width: menuWidth - CHEVRON_WIDTH }),
        }),
    }), [isCalculatingWidth, maxWidth, menuWidth, minWidth, styles]);
    return (react_1.default.createElement(react_select_1.default, { ref: selectRef, onMenuOpen: onMenuOpen, styles: dynamicStyles, menuIsOpen: menuIsOpen, ...otherProps }));
};
exports.default = SelectWithDynamicWidth;
SelectWithDynamicWidth.defaultProps = {
    maxWidth: 300,
    minWidth: 170,
    styles: EMPTY_OBJ,
};
SelectWithDynamicWidth.propTypes = {
    maxWidth: prop_types_1.default.number,
    minWidth: prop_types_1.default.number,
    styles: prop_types_1.default.object,
};
//# sourceMappingURL=select-with-dynamic-width.js.map